import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import { toast } from "react-toastify";
import individualServices from "../../Services/individualServices";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Select from "react-select";
import { locationServices } from "../../Services/locationServices";
import { PhoneCode } from "../../Components/PhoneCode";
import { customerServiceService } from "../../Services";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import csc from "country-state-city";
import helperFunction from "../../Function/helperFunction";

const GenderList = [
  { value: "MALE", label: "MALE" },
  { value: "FEMALE", label: "FEMALE" },
  { value: "OTHER", label: "OTHER" },
];

const UserTypeList = [
  { value: "TOURIST", label: "Tourist" },
  { value: "RESIDENT", label: "Resident" },
  { value: "OVERSEASCUSTOMER", label: "Overseas Shoppers" },
];

const TypeList = [
  { value: "individual", label: "Individual" },
  { value: "commercial", label: "Commercial" },
  { value: "trade_partner", label: "Trade Partner" },
];

const SubCatList = [
  { value: "GENERAL COMPANY", label: "GENERAL COMPANY" },
  { value: "PARTNERS", label: "PARTNERS" },
  { value: "LOCAL TRADE PARTNERS", label: "LOCAL TRADE PARTNERS" },
  { value: "OVERSEAS PARTNERS", label: "OVERSEAS PARTNERS" },
  { value: "MARKET PLACE", label: "MARKET PLACE" },
  { value: "RETAILERS", label: "RETAILERS" },
];

const validationSchema = Yup.object({
  address: Yup.string().required("Required"),
  // country: Yup.string().required('Required'),
  // state: Yup.string().required('Required'),
  // city: Yup.string().required('Required'),
  user_full_name: Yup.string().required("Required"),
  user_email: Yup.string()
    .required("Required")
    .email("Please enter valide email"),
  user_phone_number: Yup.string().required("Required").min(10, "Too short"),
  user_password: Yup.string()
    .min(8, "Minimum 8 Digit Password")
    .required("Required"),
  taxation_details: Yup.string().required("Required"),
  user_gender: Yup.string().required("Required"),
  user_type: Yup.string().required("Required"),
  type: Yup.string().required("Required"),
});

const validationSchema1 = Yup.object({
  user_full_name: Yup.string().required("Required"),
  user_email: Yup.string()
    .required("Required")
    .email("Please enter valide email"),
  user_phone_number: Yup.string().required("Required").min(10, "Too short"),
  user_password: Yup.string()
    .min(8, "Minimum 8 Digit Password")
    .required("Required"),
  user_gender: Yup.string().required("Required"),
  user_type: Yup.string().required("Required"),
  type: Yup.string().required("Required"),
});

const validationSchema2 = Yup.object({
  address: Yup.string().required("Required"),
  // country: Yup.string().required('Required'),
  // state: Yup.string().required('Required'),
  // city: Yup.string().required('Required'),
  user_full_name: Yup.string().required("Required"),
  user_email: Yup.string()
    .required("Required")
    .email("Please enter valide email"),
  user_phone_number: Yup.string().required("Required").min(10, "Too short"),
  user_password: Yup.string()
    .min(8, "Minimum 8 Digit Password")
    .required("Required"),
  taxation_details: Yup.string().required("Required"),
  type: Yup.string().required("Required"),
});

const initialValues = {
  //user_name: '',
  user_full_name: "",
  user_email: "",
  user_phone_number: "",
  user_password: "",
  //user_dial_code: '',
  user_gender: "",
  user_type: "",
  type: "",
  address: "",
  country: "",
  state: "",
  city: "",
  postal_code: "",
  taxation_details: "",
  sales_person: "",
  // user_country: '',
  sales_person: "",
};
export const AddIndividuals = () => {
  const history = useHistory();
  const data = history.location.state;
  const [loader, setLoader] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [destinationCountryValue, setDestinationCountryValue] = useState("");
  const [originCountryValue, setOriginCountryValue] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);
  const [validate, setValidate] = useState(validationSchema);
  const [customerServiceList, setCustomerServiceList] = useState([]);
  const [country, setCountry] = useState(csc.getAllCountries());
  const [countryCode, setCountryCode] = useState("");
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [valimg, setValimg] = useState(false);
  const [image, setImage] = useState("");

  useEffect(() => {
    getItemList();
  }, []);

  const getItemList = () => {
    let param = { role: "sales" };
    customerServiceService.getCustomerService(param).then((res) => {
      if (res.status) {
        let arr = [];
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].employee_name) {
            arr.push({
              ...res.data[i],
              value: res.data[i]?.employee_name,
              label: res.data[i]?.employee_name,
            });
          }
        }
        setCustomerServiceList(arr);
      }
    });
  };

  useEffect(() => {
    getCountryList();
  }, []);

  const formik = useFormik({
    initialValues,
    validationSchema: validate,
    onSubmit: (values) => {
      let data = new FormData();
      setLoader(true);
      let postData = {
        ...values,
        user_email: values.user_email.toLowerCase(),
        user_country: values.country,
      };
      data.append("address", values.address);
      data.append("city", values.city);
      data.append("user_country", values.country);
      data.append("state", values.state);
      data.append("postal_code", values.postal_code);
      data.append("type", values.type);
      data.append("user_email", values.user_email.toLowerCase());
      data.append("user_full_name", values.user_full_name);
      data.append("taxation_details", values.taxation_details);
      data.append("user_phone_number", values.user_phone_number);
      data.append("user_type", values.user_type);
      data.append("user_gender", values.user_gender);
      data.append("sales_person", values.sales_person);
      data.append("user_password", values.user_password);
      data.append("user_logo", values.user_logo);
      if(values.sub_category) {data.append("sub_category", values.sub_category);}

      individualServices.add_individual(data).then((res) => {
        if (res.status) {
          setLoader(false);
          history.push("individual-list");
        } else {
          setLoader(false);
          toast.error(res.message);
        }
      });
    },
  });

  const getCountryList = () => {
    locationServices.getCountry().then((res) => {
      if (res.status) {
        let arry = [];
        res.data.map((list) => {
          arry.push({ value: list._id, label: list.country_name, data: list });
        });

        let activeCountry = arry.filter(
          (item) => item.data.country_currency === "AED"
        );
        if (activeCountry.length) {
          onSelectCountry(activeCountry[0], "origin");
        }

        setCountryList(arry);
      } else {
        toast.error(res.message);
      }
    });
  };

  const onSelectCountry = (e, act) => {
    switch (act) {
      case "origin":
        setOriginCountryValue(e);
        formik.setValues({ ...formik.values, origin_country_id: e.value });

        break;
      case "destination":
        setDestinationCountryValue(e);
        formik.setValues({ ...formik.values, user_country: e.value });

        break;
    }
  };

  const onSelect = (e) => {
    formik.setValues({
      ...formik.values,
      user_gender: e.value,
    });
  };
  const onSelectType = (e) => {
    formik.setValues({
      ...formik.values,
      user_type: e.value,
    });
  };
  const onSelectW2DSales = (e, values, setValues, name) => {
    formik.setValues({
      ...values,
      [name]: e.value,
    });
  };
  const onSelectTypeUser = (e) => {
    if (e.value == "individual") {
      setValidate(validationSchema1);
    } else {
      setValidate(validationSchema2);
    }

    formik.setValues({
      ...formik.values,
      type: e.value,
    });
  };

  const onSelectSubCat = (e) => {
    // if (e.value == "individual") {
    //   setValidate(validationSchema1);
    // } else {
    //   setValidate(validationSchema2);
    // }

    formik.setValues({
      ...formik.values,
      sub_category: e.value,
    });
  };

  const onCountryChange = (e, name) => {
    if (name === "country") {
      setStates(csc.getStatesOfCountry(e.isoCode));
      setCountryCode(e.isoCode);
    } else if (name === "state") {
      setCities(csc.getCitiesOfState(countryCode, e.isoCode));
    }
    formik.setFieldValue([name], e.value);
  };

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-8">
        <div className="card">
          <div className="card-body">
            <form className="control-form" autocomplete="off">
              <div className="row">
                {/* <div className="mb-3 col-6">
                                    <label className="form-label">UserName</label>
                                    <input
                                        required={false}
                                        type="text"
                                        className={'form-control' + (formik.touched.user_name ? !formik.errors.user_name ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('user_name')}
                                        placeholder="Enter UserName"
                                    />
                                    {formik.touched.user_name && formik.errors.user_name ? (
                                        <div className="text-danger">{formik.errors.user_name}</div>
                                    ) : null}
                                </div> */}

                <div className="mb-3 col-6">
                  <label className="form-label">Individual / Commercial / Trade Partner</label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        borderColor: formik.touched.type
                          ? !formik.errors.type
                            ? "#34c38f"
                            : "#f46a6a"
                          : "#ced4da",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    // value={TypeList.find((option) => option.value === formik.values.type)}
                    onChange={(e) => onSelectTypeUser(e)}
                    options={TypeList}
                  />
                  {formik.touched.type && formik.errors.type ? (
                    <div className="text-danger">{formik.errors.type}</div>
                  ) : null}
                </div>

                {
                  (formik.values.type === "individual" || formik.values.type === "commercial") && (
                <div className="mb-3 col-6">
                  <label className="form-label">Sub Category</label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        borderColor: formik.touched.sub_category
                          ? !formik.errors.sub_category
                            ? "#34c38f"
                            : "#f46a6a"
                          : "#ced4da",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    // value={TypeList.find((option) => option.value === formik.values.type)}
                    onChange={(e) => onSelectSubCat(e)}
                    options={SubCatList}
                  />
                  {formik.touched.sub_category && formik.errors.sub_category ? (
                    <div className="text-danger">{formik.errors.sub_category}</div>
                  ) : null}
                </div>

                  )
                }

                <div className="mb-3 col-6">
                  <label className="form-label">Email ID</label>
                  <input
                    type="email"
                    className={
                      "form-control" +
                      (formik.touched.user_email
                        ? !formik.errors.user_email
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("user_email")}
                    placeholder="Enter Email"
                  />
                  {formik.touched.user_email && formik.errors.user_email ? (
                    <div className="text-danger">
                      {formik.errors.user_email}
                    </div>
                  ) : null}
                </div>

                <div className="mb-3 col-6">
                  <label className="form-label">FullName</label>
                  <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.touched.user_full_name
                        ? !formik.errors.user_full_name
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("user_full_name")}
                    placeholder="Enter FullName"
                  />
                  {formik.touched.user_full_name &&
                  formik.errors.user_full_name ? (
                    <div className="text-danger">
                      {formik.errors.user_full_name}
                    </div>
                  ) : null}
                </div>
                <div className="mb-3 col-6">
                  <label className="form-label">Taxation Details</label>
                  <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.touched.taxation_details
                        ? !formik.errors.taxation_details
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("taxation_details")}
                    placeholder="Enter Taxation Details"
                  />
                  {formik.touched.taxation_details &&
                  formik.errors.taxation_details ? (
                    <div className="text-danger">
                      {formik.errors.taxation_details}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="mb-3 col-6">
                  <div className="form-group">
                    <label className="form-label">Contact No.</label>
                    <div
                      className={
                        formik.touched.user_phone_number
                          ? !formik.errors.user_phone_number
                            ? " contact-success"
                            : " contact-error"
                          : ""
                      }
                    >
                      <PhoneCode
                        Addphone={(value) =>
                          formik.setValues({
                            ...formik.values,
                            user_phone_number: value,
                          })
                        }
                        phone={formik.values.user_phone_number}
                      />
                    </div>
                  </div>
                  {formik.touched.user_phone_number &&
                  formik.errors.user_phone_number ? (
                    <div className="text-danger">
                      {formik.errors.user_phone_number}
                    </div>
                  ) : null}
                </div>
                <div className="mb-3 col-6">
                  <label className="form-label">User Type </label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        borderColor: formik.touched.user_type
                          ? !formik.errors.user_type
                            ? "#34c38f"
                            : "#f46a6a"
                          : "#ced4da",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    // value={Gender}
                    // isOptionDisabled={(option) => option.isdisabled}
                    onChange={(e) => onSelectType(e)}
                    options={UserTypeList}
                  />
                  {formik.touched.user_type && formik.errors.user_type ? (
                    <div className="text-danger">{formik.errors.user_type}</div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-6">
                  <label className="form-label">Registered Address</label>
                  <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.touched.address
                        ? !formik.errors.address
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("address")}
                    placeholder="Enter Address"
                  />
                  {formik.touched.address && formik.errors.address ? (
                    <div className="text-danger">{formik.errors.address}</div>
                  ) : null}
                </div>

                <div className="mb-3 col-3">
                  <label className="form-label">Country </label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        borderColor: formik.touched.country
                          ? !formik.errors.country
                            ? "#34c38f"
                            : "#f46a6a"
                          : "#ced4da",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    onChange={(e) => onCountryChange(e, "country")}
                    options={helperFunction.convertToSelectList(
                      country,
                      "name",
                      "name"
                    )}
                  />
                  {/* {formik.touched.country && formik.errors.country ? (
                    <div className="text-danger">
                      {formik.errors.country}
                    </div>
                  ) : null} */}
                </div>
                <div className="mb-3 col-3">
                  <label className="form-label">State </label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        borderColor: formik.touched.state
                          ? !formik.errors.state
                            ? "#34c38f"
                            : "#f46a6a"
                          : "#ced4da",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    onChange={(e) => onCountryChange(e, "state")}
                    options={helperFunction.convertToSelectList(
                      states,
                      "name",
                      "name"
                    )}
                    // onChange={(e) => onSelect(e)}
                    // options={GenderList}
                  />
                  {/* {formik.touched.state && formik.errors.state ? (
                    <div className="text-danger">
                      {formik.errors.state}
                    </div>
                  ) : null} */}
                </div>

                <div className="mb-3 col-6">
                  <label className="form-label">Gender </label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        borderColor: formik.touched.user_gender
                          ? !formik.errors.user_gender
                            ? "#34c38f"
                            : "#f46a6a"
                          : "#ced4da",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    // value={Gender}
                    // isOptionDisabled={(option) => option.isdisabled}
                    onChange={(e) => onSelect(e)}
                    options={GenderList}
                  />
                  {formik.touched.user_gender && formik.errors.user_gender ? (
                    <div className="text-danger">
                      {formik.errors.user_gender}
                    </div>
                  ) : null}
                </div>

                <div className="mb-3 col-3">
                  <label className="form-label">City</label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        borderColor: formik.touched.city
                          ? !formik.errors.city
                            ? "#34c38f"
                            : "#f46a6a"
                          : "#ced4da",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    onChange={(e) => formik.setFieldValue("city", e.value)}
                    options={helperFunction.convertToSelectList(
                      cities,
                      "name",
                      "name"
                    )}
                  />
                  {/* {formik.touched.city && formik.errors.city ? (
                    <div className="text-danger">
                      {formik.errors.city}
                    </div>
                  ) : null} */}
                </div>
                <div className="mb-3 col-3">
                  <label className="form-label">Postal Code</label>
                  <input
                    type="text"
                    className={"form-control"}
                    {...formik.getFieldProps("postal_code")}
                    placeholder="Enter Postal Code"
                  />
                </div>

                <div className="mb-3 col-6">
                  <label className="form-label">W2D Sales Person</label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        borderColor: formik.touched.sales_person
                          ? !formik.errors.sales_person
                            ? "#34c38f"
                            : "#f46a6a"
                          : "#ced4da",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    options={customerServiceList}
                    onChange={(e) =>
                      onSelectW2DSales(
                        e,
                        formik.values,
                        formik.setValues,
                        "sales_person"
                      )
                    }
                    value={customerServiceList.find(
                      (item) =>
                        item?.employee_name === formik.values?.sales_person
                    )}
                  />
                  {formik.touched.sales_person && formik.errors.sales_person ? (
                    <div className="text-danger">
                      {formik.errors.sales_person}
                    </div>
                  ) : null}
                </div>

                <div className="mb-3 col-6">
                  <label className="form-label">Password</label>
                  <div className="d-flex">
                    <input
                      type={togglePassword ? "text" : "password"}
                      className={
                        "form-control no-border-right no-border-end" +
                        (formik.touched.user_password
                          ? !formik.errors.user_password
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("user_password")}
                      placeholder="Enter Password"
                      autocomplete="new-password"
                    />
                    <button
                      type="button"
                      className="btn-primary"
                      onClick={() => setTogglePassword(!togglePassword)}
                    >
                      {togglePassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>
                  {formik.touched.address && formik.errors.user_password ? (
                    <div className="text-danger">
                      {formik.errors.user_password}
                    </div>
                  ) : null}
                </div>


                {formik.values.type === "trade_partner" && (
                  <div className="mb-3 col-6">
                    <label className="form-label">Logo</label>
                      <input
                        required={false}
                        type="file"
                        className={
                          "form-control" +
                          (formik.touched.user_logo
                            ? !formik.errors.user_logo
                              ? " is-valid"
                              : " is-invalid"
                            : "")
                        }
                        onChange={(e) => {
                          if (
                            e.target.files[0].name.split(".").at(-1) === "svg"
                          ) {
                            setValimg(true);
                          } else {
                            setValimg(false);
                            formik.setFieldValue(
                              "user_logo",
                              e.target.files[0]
                            );
                            // setImage(URL.createObjectURL(e.target.files[0]));
                            setImage({
                              imageurl: URL.createObjectURL(e.target.files[0]),
                              image: e.target.files,
                            });
                          }
                        }}
                      />
                      {valimg === true && (
                        <p className="text-danger">
                          Uploaded file has unsupported format
                        </p>
                      )}
                      {formik.touched.user_logo && formik.errors.user_logo ? (
                        <div className="text-danger">
                          {formik.errors.user_logo}
                        </div>
                      ) : null}
                    {formik.touched.address && formik.errors.user_logo ? (
                      <div className="text-danger">
                        {formik.errors.user_logo}
                      </div>
                    ) : null}
                  </div>
                )}


              </div>

              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => formik.handleSubmit()}
                >
                  Submit
                </button>
              </div>
            </form>
            {/* <Loader isShow={loader} /> */}
          </div>
        </div>
      </div>
    </div>
  );
};
